import './Popover.scss'
import Popover from 'react-popover-wrapper'

export default Popover



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/components/Popover/Popover.jsx